import { Button, Layout, Tag, Accordion } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { formatDate, formatDescriptionWithZip } from 'core/presenters/stopPresenter'
import { ShipmentTags } from 'core/shipment-tag/ui/ShipmentTags'
import { CardInfoItem } from 'core/ui/components/card/CardInfoItem'
import { Logo } from 'core/ui/components/logo/Logo'

import { formatEquipment } from '../presenters/agnosticShipmentPresenter'
import { LastLocation } from './LastLocation'
import { MobileStopsTimeline } from './MobileStopsTimeline'
import { type ShipmentCardProps } from './ShipmentCard'
import { ShipmentIdentifiers } from './ShipmentIdentifiers'
import { ShipmentListChat } from './ShipmentListChat'

export function ShipmentCardMobile({
  shipment,
  getActionLabel,
  getIdentifiers,
  getStatus,
  onActionClick,
}: ShipmentCardProps) {
  const actionLabel = getActionLabel?.()
  const identifiers = getIdentifiers?.()
  const { label, variant } = getStatus?.() ?? {}
  const {
    stops,
    shipper,
    mode,
    equipmentType,
    equipmentLength,
    equipmentSubType,
    poNumbers,
    soNumbers,
    bolNumber,
  } = shipment

  function handleOnActionClick(event: React.MouseEvent) {
    event.stopPropagation()
    onActionClick?.()
  }

  return (
    <Layout.Box
      backgroundColor="color-background-primary"
      borderRadius="border-radius-s"
      borderWidth="border-thin"
      borderColor="color-border"
      padding="none"
      style={{ display: 'block' }}
      data-testid="shipment-card-mobile"
    >
      <Layout.Stack gap="spacing-4" style={{ padding: getToken('spacing-4') }}>
        <Layout.Group gap="spacing-2" align="center" style={{ flexWrap: 'wrap' }}>
          <Tag variant={variant} size="small">
            {label}
          </Tag>
          <ShipmentTags tags={shipment.tags} size="small" />
          <ShipmentIdentifiers identifiers={identifiers} />
        </Layout.Group>
        <Layout.Group justify="space-between" align="flex-end" style={{ flexWrap: 'nowrap' }}>
          <MobileStopsTimeline
            stops={stops}
            titleFormatter={formatDescriptionWithZip}
            subTitleFormatter={formatDate}
          />
          <ShipmentListChat shipment={shipment} size="small" />
        </Layout.Group>
        <Accordion>
          <Accordion.Title>Overview</Accordion.Title>
          <Accordion.Content>
            <Layout.Stack gap="spacing-6">
              <Layout.Group>
                {shipper?.logoUrl && <Logo url={shipper.logoUrl} />}
                {shipper?.companyName && (
                  <CardInfoItem title="Shipper" value={shipper?.companyName} />
                )}
              </Layout.Group>
              <Layout.Group>
                <CardInfoItem title="Mode" value={mode} />
                <CardInfoItem
                  title="Equipment"
                  value={formatEquipment(equipmentType, equipmentLength)}
                />
                {equipmentSubType && (
                  <CardInfoItem title="Sub Equipment" value={equipmentSubType} />
                )}
              </Layout.Group>
              {bolNumber && <CardInfoItem title="BOL#" value={bolNumber} />}
              {poNumbers && <CardInfoItem title="PO#" value={poNumbers.join(', ')} />}
              {soNumbers && <CardInfoItem title="SO#" value={soNumbers.join(', ')} />}
            </Layout.Stack>
          </Accordion.Content>
        </Accordion>
        {actionLabel && (
          <Button variant="secondary" type="button" onClick={handleOnActionClick}>
            {actionLabel}
          </Button>
        )}
      </Layout.Stack>
      <LastLocation shipment={shipment} />
    </Layout.Box>
  )
}
